module.exports = __webpack_public_path__ + "static/media/notifcation-sound.4eea25d7.mp3";